<div class="input-group">

  <span class="input-group-addon">
    <i class="glyphicon glyphicon-search"></i>
  </span>

  <ng-template #searchResultTemplate let-result="item" let-index="index">
    <table style="width: 95%; position: relative; width: 290px;">
      <tr style="width: 100%">
        <td style="width: 70%">
          {{ result.personName }}
        </td>
        <ng-template [featureFlags]="['resource:pets']">
            <td *ngIf="result.petsName !== undefined" style="width: 30%">
              ( {{ result.petsName }} )
            </td>
        </ng-template>
      </tr>
    </table>
  </ng-template>

  <input #patientSearchInput
         type="text"
         class="form-control"
         style="width: 300px"
         placeholder="{{'_PatientSearchPlaceHolder_' + searchByPet + '_' | translate}}"
         autocomplete="off"
         typeaheadOptionField="personName"
         [typeaheadMinLength]="0"
         [ngModel]="selectedPatient.personName"
         [typeahead]="foundPatients$"
         [typeaheadAsync]="true"
         [typeaheadItemTemplate]="searchResultTemplate"
         (typeaheadOnSelect)="onSelect($event)"/>
</div>
<ng-template [featureFlags]="['resource:pets']">
  <div class="btn-group btn-toggle" style="padding-left: 16px">
    <button class="btn btn-lg"  style="font-size: 13px" (click)="searchBy()" [ngClass]="{ 'btn-default': searchByPet, 'btn-primary active': !searchByPet}">Client</button>
    <button class="btn btn-lg" style="font-size: 13px"  (click)="searchBy()" [ngClass]="{ 'btn-default': !searchByPet, 'btn-primary active': searchByPet}">Pet</button>
  </div>
</ng-template>